import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_ACTIONS } from '../../constants/action.constants';
import { OFFERINGS_PATH } from '../../constants/paths.constants';
import {
  clearLoginTime,
  clearRefreshToken,
  clearToken,
  clearTokenExpiration,
  getToken
} from '../../services/session.storage';

function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const token = getToken();
    if (token) {
      clearToken();
      clearRefreshToken();
      clearTokenExpiration();
      clearLoginTime();
      dispatch({ type: AUTH_ACTIONS.RESET });
      navigate(OFFERINGS_PATH);
    }
  }, [navigate, dispatch, location]);

  return <h2 className="u-margin-top-xx u-text-center">Je bent uitgelogd.</h2>;
}

export default Logout;
